import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function Origin() {
  return <section className="py-24 lg:py-40 bg-warm-sand relative overflow-hidden" data-id="element-155">
      {/* Subtle architectural imagery */}
      <div className="absolute inset-0 opacity-[0.04]" data-id="element-156">
        <img src="https://images.unsplash.com/photo-1486325212027-8081e485255e?auto=format&fit=crop&q=80&w=1920" alt="" className="w-full h-full object-cover" data-id="element-157" />
      </div>

      <div className="max-w-5xl mx-auto px-6 lg:px-8 relative z-10 text-center" data-id="element-158">
        <FadeIn data-id="element-159">
          <p className="text-[11px] font-semibold tracking-[0.4em] uppercase text-vivid-orange mb-10" data-id="element-160">
            Our Evolution
          </p>

          <h2 className="text-4xl md:text-6xl lg:text-7xl font-display font-medium leading-[1.05] text-deep-azure mb-4" data-id="element-161">
            From Side Hustle
          </h2>
          <h2 className="text-4xl md:text-6xl lg:text-7xl font-display italic font-light leading-[1.05] text-vivid-orange mb-16" data-id="element-162">
            to LeadHERship™
          </h2>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-163">
          <div className="editorial-rule w-32 mx-auto mb-16" data-id="element-164"></div>
        </FadeIn>

        <FadeIn delay={0.3} data-id="element-165">
          <div className="max-w-3xl mx-auto space-y-8 text-lg md:text-xl text-charcoal-navy/80 leading-relaxed font-light" data-id="element-166">
            <p data-id="element-167">
              After supporting more than 225 women-led businesses through
              mentorship, programming, and founder initiatives, one reality
              became clear:
            </p>
            <p className="font-display italic text-2xl md:text-3xl text-deep-azure leading-snug py-4" data-id="element-168">
              "Women founders are not lacking ambition. They are lacking aligned
              infrastructure, measurable support, execution-based programming,
              and accessible growth pathways."
            </p>
            <p data-id="element-169">
              LeadHERship Equity represents the next evolution — moving beyond
              inspiration into measurable advancement.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}